<script lang="ts" setup>
import { computed } from 'vue';
import HighlightBox from '@/molecules/HighlightBox.vue';
import BaseLabel from '@/atoms/BaseLabel.vue';

defineEmits(['back', 'next', 'submit', 'canSubmit']);

const props = defineProps<{
  data: any;
}>();

type Color = 'success' | 'warning' | 'error';

function getPssColor(score: number): Color {
  if (score < 14) return 'success';
  if (score < 27) return 'warning';
  return 'error';
}

function getEvaColor(score: number): Color {
  if (score < 4) return 'success';
  if (score < 7) return 'warning';
  return 'error';
}

const pssScore = computed(() => props.data?.total_stress_score);
const evaValue = computed(() => props.data?.eva_value);

const pssColor = computed<Color>(() =>
  pssScore.value != null ? getPssColor(Number(pssScore.value)) : 'error',
);
const evaColor = computed<Color>(() =>
  evaValue.value != null ? getEvaColor(Number(evaValue.value)) : 'error',
);
</script>

<template>
  <div class="space-y-6">
    <div v-if="pssScore != null" class="space-y-2">
      <BaseLabel color="secondary" preset="body" text="Questionnaire PSS" weight="medium" />
      <HighlightBox :color="pssColor" :value="pssScore" suffix="/ 40" />
    </div>

    <div v-if="evaValue != null" class="space-y-2">
      <BaseLabel color="secondary" preset="body" text="Échelle de stress (EVA)" weight="medium" />
      <HighlightBox :color="evaColor" :value="evaValue" suffix="/ 100" />
    </div>

    <div v-if="pssScore == null && evaValue == null" class="text-center py-8">
      <BaseLabel color="secondary" preset="body" text="Aucun score de stress disponible" />
    </div>
  </div>
</template>
